export default __webpack_public_path__ + "0f23eee31d76ada58917c644bd8f745e.png";